import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToTop } from '@sanlam-glacier/app-common/utils';

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    scrollToTop();
  }, [pathname]);

  return null;
};
